import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Head from '../../components/Head';
import Layout from '../../layout';
import useStyles from './styles';

const Notifications = () => {
  const classes = useStyles();

  return (
    <Layout page="notifications" innerPage>
      <Head>Notificações</Head>
      <Container className={classes.container}>
        <Typography variant="h2">Últimas Notificações</Typography>
      </Container>
    </Layout>
  );
}

export default Notifications;